import { Chip, DropdownItem, InfoItem } from '@frk/eds-components';
import {
  AssetClass,
  FundId,
  FundShareClassId,
  ShareClassCode,
  ShareClassName,
  SwitchState,
  WebProductTaxonomy,
} from '.';

import { ProductType } from './product-type.type';
import { UsTax } from '@products/models/us-tax';

/**
 * ********** Tax Types **********
 */
export interface TaxState {
  taxData?: UsTax;
  years?: number[];
  currentYear?: number;
  noDataMessage?: string;
  federalTaxId?: string;
  stateCols?: number;
  pdf?: string;
}

/**
 * ********** Capital Gains Types **********
 */
export interface TaxListInfoState {
  taxListInfoListing?: TaxListInfoListing[]; // stores original formatted listing.
  gridListing?: TaxListInfoListing[]; // for, filtered listing.
  filters?: TaxListInfoFilterType[];
  recordDetails?: TaxListInfoRecordDetails;
  isLoaded?: boolean;
  action?: TaxListInfoAction;
  taxYear?: string;
}

export interface TaxListInfoListing {
  fundId: FundId;
  fundName: string;
  shareClassCode: ShareClassCode;
  fundShareClassId: FundShareClassId; // used as a unique id
  isPrimaryShareClass: boolean;
  productType: ProductType;
  assetClass: AssetClass;
  investmentGroup: string;
  taxYear: string;
  cusip: string;
  ticker: string;
  foreignSourceIncome: string;
  foreignSourceQualifiedDividends: string;
  directUSGovernmentObligations: string;
  specifiedPvtActivityBondInterest: string;
  dividendsReceivedDeduction: string;
  section163: string;
  indianaResidentTaxableIncome: string;
  utahResidentTaxableIncome: string;
  stateFlag: boolean;
  primaryShareClass: string;
  taId: string;
  productTaxonomy: WebProductTaxonomy;
  link?: string;
  fundStatus?: keyof typeof TaxListInfoFundStatus;
  shareClassName: ShareClassName;
  isFavorite?: boolean;
  isSelected?: boolean;
  isChecked?: boolean;
  isTaxExemptAvailable?: boolean;
  taxExemptData?: InfoItem[];
  isSoftLaunchShareClass?: boolean;
}

export enum TaxListInfoFundStatus {
  active = 'active',
  inactive = 'inactive',
  'soft-launch' = 'soft-launch',
  'soft-closed' = 'soft-closed',
}

export type TaxListInfoFilterType = {
  filterLabel?: string;
  filterName: string;
  filterItems: DropdownItem[];
};

export interface TaxListInfoTotalPages {
  count: number;
}

export interface TaxListInfoRecordsCount {
  total: number; // total number of records available from feed.
  filtered: number; // total number of records to be shown in paginated list (filtered list).
  size: number; // total number of records to be shown in one page.
}

export interface TaxListInfoSelectedFilter {
  filterType: string;
  filterOptions: Chip[];
}

export interface TaxListInfoRecordDetails {
  total: number;
  filtered: number;
}

export enum TaxListInfoAction {
  'INITIAL_LOAD', // Initial load of the page
  'FILTER_ROWS', // Filter selection(s) happened.
}

export interface TaxListInfoSelectedFilters {
  selectedDropdowns?: TaxListInfoFilterType[];
  searchedText?: string;
}

export interface TaxListInfoToggleState {
  showFavoritesOnlySwitch: boolean;
  favoritesOnlySwitchState?: SwitchState;
}

export interface TaxInfoStateList {
  fundId?: FundId;
  states?: InfoItem[];
}

export interface TaxInfoStateParam {
  fundId?: FundId;
  shareClassCode?: ShareClassCode;
  year?: number;
}
export enum CheckboxSelectType {
  INDIVIDUAL = 'INDIVIDUAL',
  ALL = 'ALL',
}

export interface TaxInfoStickySelectEvent {
  checkedItems?: TaxListInfoListing[];
  isChecked?: boolean;
  item?: TaxListInfoListing;
  itemsChanged?: CheckboxSelectType;
}
export enum TaxInfoDownloadType {
  SINGLE = 'SINGLE',
  FILTERED = 'FILTERED',
  FAVORITE = 'FAVORITE',
  ALL = 'ALL',
  SELECTED = 'SELECTED',
}
export type ColumnDefs = {
  s: string;
  m: string;
  l: string;
};
export enum TaxInfoPrintType {
  SINGLE = 'SINGLE',
  SELECTED = 'SELECTED',
}

export enum FILTER_DEFAULT_CLASS {
  ASSET_CLASS = 'assetClass',
  PRODUCT_TYPE = 'productType',
  INVESTMENT_GROUP = 'investmentGroup',
  TAX_DATAPOINT = 'taxDataPoint',
  FILTER_BY_KEYWORDS = 'filterByKeywords',
}
